
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terraform-module/[postId]",
      function () {
        return require("private-next-pages/terraform-module/[postId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terraform-module/[postId]"])
      });
    }
  